// Auto generated by typegen from Prisma Schema

export enum PremiumSource {
	OP_LINE = "OP_LINE",
	SHIPPING_TIER = "SHIPPING_TIER",
}

export enum BillType {
	card = "card",
	ach = "ach",
}

export enum CreditType {
	BILL = "BILL",
	PAYOUT = "PAYOUT",
}

export enum PolicyType {
	SHIPPING = "SHIPPING",
	MANUFACTURER_WARRANTY = "MANUFACTURER_WARRANTY",
	EXTENDED_WARRANTY = "EXTENDED_WARRANTY",
}

export enum CorrectionType {
	INVOICE = "INVOICE",
	PAYOUT = "PAYOUT",
	DISCOUNT = "DISCOUNT",
}

export enum Cycle {
	DAILY = "DAILY",
	WEEKLY = "WEEKLY",
	BIWEEKLY = "BIWEEKLY",
	MONTHLY = "MONTHLY",
}

export enum Cadence {
	AUTOMATIC = "AUTOMATIC",
	INVOICE = "INVOICE",
	NO_AUTOMATION = "NO_AUTOMATION",
}

export enum InvoiceModel {
	STANDARD = "STANDARD",
	SUBSCRIPTION = "SUBSCRIPTION",
	TIERED_SUBSCRIPTION = "TIERED_SUBSCRIPTION",
}

export enum BillingType {
	STANDARD = "STANDARD",
	HYBRID = "HYBRID",
}

export enum BillingModel {
	NET = "NET",
}

export enum PayoutModel {
	STANDARD = "STANDARD",
	REVENUE_SHARE = "REVENUE_SHARE",
	THRESHOLD = "THRESHOLD",
	NO_MODEL = "NO_MODEL",
	REIMBURSEMENTS_AND_PREMIUMS = "REIMBURSEMENTS_AND_PREMIUMS",
	REIMBURSEMENTS_AND_REV_SHARE = "REIMBURSEMENTS_AND_REV_SHARE",
}

export enum MarginThresholdType {
	PREMIUMS = "PREMIUMS",
	RESOLUTIONS = "RESOLUTIONS",
	BOTH = "BOTH",
}

export enum InvoiceStatus {
	NO_PAYMENT_PROFILE = "NO_PAYMENT_PROFILE",
	INVOICE_CREATED = "INVOICE_CREATED",
	INVOICE_WAIVED = "INVOICE_WAIVED",
	CHARGE_PENDING = "CHARGE_PENDING",
	CHARGE_SUCCESSFUL = "CHARGE_SUCCESSFUL",
	CHARGE_DECLINED = "CHARGE_DECLINED",
}

export enum PartnerPayoutStatus {
	PENDING = "PENDING",
	PAID = "PAID",
}

export enum PayoutStatus {
	PAID = "PAID",
	PROCESSING = "PROCESSING",
	PENDING = "PENDING",
}

export enum PayoutType {
	REVENUE_SHARE = "REVENUE_SHARE",
	RESOLUTION = "RESOLUTION",
	ONE_TIME_PAYOUT = "ONE_TIME_PAYOUT",
}

export enum Platform {
	QUICKBOOKS = "QUICKBOOKS",
}

export interface Invoice {
	id: string;
	startDate: string;
	endDate: string;
	totalAmount: number;
	totalDiscount: number;
	totalCanceled: number;
	totalCredited: number;
	totalCorrection: number;
	totalCount: number;
	baseAmount: number;
	usageAmount: number;
	finalRevenue: number;
	chargeAttempts: number | null;
	brandFundedAmount: number;
	consumerFundedAmount: number;
	warrantyAmount: number;
	shippingAmount: number;
	payoutAmount: number;
	revenueShareAmount: number;
	resolutionAmount: number;
	outerMonthResolutionAmount: number;
	includedInShippingAmount: number;
	status: InvoiceStatus;
	storeId: string | null;
	legacyStoreId: number | null;
	quickbooksInvoiceId: string;
	authorizeNetChargeId: string | null;
	quickbooksPaymentId: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	bills: Bill[];
	refundedBills: Bill[];
	resolutionCredits: ResolutionCredit[];
	partnerPayouts: PartnerPayout[];
}

export interface Bill {
	id: string;
	customerId: string | null;
	storeId: string | null;
	legacyStoreId: number | null;
	date: string;
	amount: number;
	customerAmount: number;
	brandAmount: number;
	discount: number;
	fundedBy: string;
	orderId: string | null;
	orderTotal: number | null;
	legacyOrderId: number | null;
	sourceOrderId: string;
	sourceOrderName: string;
	payoutId: string | null;
	policyId: string | null;
	invoiceId: string | null;
	policyType: PolicyType;
	premiumSource: PremiumSource;
	refundedInvoiceId: string | null;
	refundedPayoutId: string | null;
	createdAt: string;
	updatedAt: string;
	voidedAt: string | null;
	deletedAt: string | null;
	invoice: Invoice | null;
	refundedInvoice: Invoice | null;
	payout: Payout | null;
	refundedPayout: Payout | null;
	policy: ResolutionCredit[];
	billMetadata: BillMetadata | null;
	correction: Correction[];
}

export interface BillMetadata {
	id: string;
	billId: string;
	addedBy: string;
	addedAt: string;
	bill: Bill;
}

export interface Plan {
	id: string;
	baseFee: number;
	usageFeePercentage: number;
	tieredUsageFee: object | null;
	shippingRevSharePercentage: number;
	extendedWarrantyRevSharePercentage: number | null;
	invoiceCycle: Cycle;
	invoiceModel: InvoiceModel;
	excludeDiscounts: boolean;
	deductNetDiscounts: boolean;
	storeId: string | null;
	legacyStoreId: number | null;
	createdAt: string;
	voidedAt: string | null;
	marginThreshold: number | null;
	marginThresholdType: MarginThresholdType | null;
	deletedAt: string | null;
	billingSettings: BillingSettings | null;
}

export interface BillingSettings {
	id: string;
	storeId: string | null;
	accountId: string | null;
	invoiceCadence: Cadence;
	payoutCycle: Cycle;
	payoutCadence: Cadence;
	invoiceModel: InvoiceModel;
	payoutModel: PayoutModel;
	billingType: BillingType;
	billingModel: BillingModel | null;
	planId: string | null;
	legacyStoreId: number | null;
	legacyMerchantId: number | null;
	createdAt: string;
	voidedAt: string | null;
	deletedAt: string | null;
	plan: Plan | null;
	exemptedEmails: string | null;
}

export interface BillingInformation {
	id: string;
	accountId: string | null;
	aNetProfileId: string;
	aNetPaymentProfileId: string;
	billType: BillType | null;
	legacyMerchantId: number | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	stores: StoresBillingInformation[];
}

export interface StoresBillingInformation {
	id: string;
	storeId: string | null;
	legacyStoreId: number | null;
	billingInformationId: string;
	voidedAt: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	billingInformation: BillingInformation;
}

export interface Correction {
	id: string;
	correctionType: CorrectionType;
	amount: number;
	amountUsed: number;
	sourceId: string | null;
	usedId: string | null;
	storeId: string | null;
	legacyStoreId: number | null;
	billId: string | null;
	resolutionCreditId: string | null;
	reason: string | null;
	createdAt: string;
	updatedAt: string | null;
	usedAt: string | null;
	deletedAt: string | null;
	bill: Bill | null;
	resolutionCredit: ResolutionCredit | null;
}

export interface Token {
	id: string;
	platform: Platform;
	accessToken: string;
	refreshToken: string;
}

export interface BillPayInfo {
	id: string;
	storeId: string | null;
	accountId: string | null;
	quickbooksId: string | null;
	billingEmail: string;
	storeName: string;
	legacyStoreId: number | null;
	legacyMerchantId: number | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
}

export interface Payout {
	id: string;
	storeId: string | null;
	startDate: string;
	endDate: string;
	revenueAmount: number;
	revenueShareAmount: number;
	shippingRevenueShareAmount: number | null;
	extendedWarrantyRevenueShareAmount: number | null;
	resolutionAmount: number;
	shippingResolution: number;
	warrantyResolution: number;
	outerMonthResolutionAmount: number;
	notCreditedAmount: number;
	correctionAmount: number;
	discountAmount: number;
	finalAmount: number;
	retainedAmount: number;
	includedInShippingAmount: number;
	payoutType: PayoutType;
	status: PayoutStatus;
	tipaltiPayoutId: string | null;
	legacyStoreId: number | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	payout: ResolutionCredit[];
	currentSettlements: PayoutSettlement[];
	priorSettlements: PayoutSettlement[];
	bills: Bill[];
	refundedBills: Bill[];
}

export interface ResolutionCredit {
	id: string;
	storeId: string | null;
	date: string;
	amount: number;
	coveredAmount: number;
	creditStore: boolean;
	isOta: boolean;
	payoutId: string | null;
	policyId: string | null;
	resolutionId: string | null;
	invoiceId: string | null;
	legacyStoreId: number | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	policy: Bill | null;
	payout: Payout | null;
	invoice: Invoice | null;
	correction: Correction[];
	settlement: PayoutCreditSettlement | null;
	lines: ResolutionCreditLine[];
	resolutionCreditDetail: ResolutionCreditDetail | null;
}

export interface ResolutionCreditLine {
	id: string;
	resolutionCreditId: string;
	claimType: string;
	coveredAmount: number;
	coverageRuleId: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	resolutionCredit: ResolutionCredit;
}

export interface PayoutCreditSettlement {
	id: string;
	creditId: string;
	payoutSettlementId: string | null;
	excessReimbursed: number;
	revShareReversed: number;
	createdAt: string;
	credit: ResolutionCredit;
	payoutSettlement: PayoutSettlement | null;
}

export interface PayoutSettlement {
	id: string;
	currentPayoutId: string;
	priorPayoutId: string;
	effectiveRevShare: number;
	effectiveResolution: number;
	retroOwed: number;
	createdAt: string;
	currentPayout: Payout;
	priorPayout: Payout;
	creditSettlements: PayoutCreditSettlement[];
}

export interface ResolutionCreditDetail {
	id: string;
	resolutionCreditId: string;
	claimId: string;
	claimDate: string;
	claimType: string;
	resolutionType: string | null;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	resolutionCredit: ResolutionCredit | null;
}

export interface PayoutMethods {
	id: string;
	storeId: string | null;
	accountId: string | null;
	tipaltiId: string | null;
	isPayable: boolean;
	payeeBankName: string | null;
	payeeBankDigits: string | null;
	payeeDisplayName: string | null;
	legacyStoreId: number | null;
	legacyMerchantId: number | null;
	createdAt: string;
	updatedAt: string | null;
	voidedAt: string | null;
	deletedAt: string | null;
}

export interface PartnerPlan {
	id: string;
	partnerAccountId: string;
	storeId: string;
	partnerPercentage: number;
	createdAt: string;
	voidedAt: string | null;
}

export interface PartnerPayout {
	id: string;
	partnerAccountId: string;
	storeId: string;
	invoiceId: string | null;
	startDate: string;
	endDate: string;
	premiumAmount: number;
	discountAmount: number;
	canceledAmount: number;
	partnerShare: number;
	status: PartnerPayoutStatus;
	createdAt: string;
	updatedAt: string | null;
	invoice: Invoice | null;
}

